module.exports = __webpack_public_path__ + "img/expostyle_0045_anthracite_pantone425c.cdd3bdfc.jpg";